import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { SignDocumentApi } from "../SignDocuments/Models/Api";
import type { SignDocument } from "../SignDocuments/Models/Domain";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import camelize from "@/Utils/Camelize";

const SignDocumentTransformer: TransformerExtended<SignDocument, SignDocumentApi> = {
  ...DefaultTransformerGenerator<SignDocument, SignDocumentApi>(),

  toDomain(input: SignDocumentApi): SignDocument {
    return camelize<SignDocumentApi>(input) as SignDocument;
  },
};

export type SignDocumentTransformerType = TransformerExtended<SignDocument, SignDocumentApi>;

export default SignDocumentTransformer;
